"use client";

import { useSyncExternalStore } from "react";
function subscribe() {
  return () => {};
}
function getClientSnapshot() {
  return true;
}

/** `false` on server and during hydration — avoids SSR/client query-state mismatches. */
function getServerSnapshot() {
  return false;
}
export function useIsClient() {
  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
}